var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.entity
        ? _c("app-detail-header", {
            attrs: {
              "show-toggle": true,
              entity: _vm.entity,
              "show-new": false,
              "show-print": false,
              "show-delete": false,
              "show-save": true,
            },
            on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
          })
        : _vm._e(),
      _c("div", { staticClass: "columns is-gapless" }, [
        _c(
          "div",
          { staticClass: "column is-narrow" },
          [
            _vm.entity
              ? _c("user-side-menu", {
                  ref: "sideMenu",
                  attrs: {
                    "entity-name": `${_vm.entity.username}`,
                    "is-mobile-app-user": _vm.isMobileAppUser,
                  },
                  model: {
                    value: _vm.entity,
                    callback: function ($$v) {
                      _vm.entity = $$v
                    },
                    expression: "entity",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column" },
          [
            _vm.entity
              ? _c("router-view", {
                  key: _vm.$route.fullPath,
                  ref: "currentChild",
                  attrs: {
                    "is-tiled": false,
                    "route-name": _vm.$route.name,
                    "is-allowed-access-new-pwa": _vm.isAllowedAccessNewPWA,
                  },
                  on: {
                    "mobile-app-user-changed": function ($event) {
                      _vm.isMobileUser = $event
                    },
                  },
                  model: {
                    value: _vm.entity,
                    callback: function ($$v) {
                      _vm.entity = $$v
                    },
                    expression: "entity",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c(
        "unsaved-modal",
        {
          attrs: { active: _vm.isUnsavedModalActive },
          on: {
            "update:active": function ($event) {
              _vm.isUnsavedModalActive = $event
            },
            close: function ($event) {
              return _vm.closeModal()
            },
            skipSave: function ($event) {
              return _vm.skipSave()
            },
            saveContinue: function ($event) {
              return _vm.saveContinue()
            },
          },
        },
        [
          _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
            _vm._v("Unsaved Changes"),
          ]),
          _c("p", { attrs: { slot: "text-content" }, slot: "text-content" }, [
            _vm._v("There are unsaved changes. Please select action below"),
          ]),
        ]
      ),
      _c(
        "save-conflict-modal",
        {
          attrs: { active: _vm.isSaveConflictModalActive },
          on: {
            "update:active": function ($event) {
              _vm.isSaveConflictModalActive = $event
            },
            close: function ($event) {
              return _vm.closeModal()
            },
            reload: function ($event) {
              return _vm.reloadData()
            },
          },
        },
        [
          _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
            _vm._v("Change conflict"),
          ]),
          _c("p", { attrs: { slot: "text-content" }, slot: "text-content" }, [
            _vm._v(
              "The data on the server is newer than the local copy. Please reload local data."
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }